import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@zshared/shared.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthService } from '@zlib/services/auth.service';
// import { ChangePasswordComponent } from './pages/change-password/change-password.component';
// import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
// import { LoginComponent } from './pages/login/login.component';
// import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
// import { SetPasswordComponent } from './pages/set-password/set-password.component';

const NZ_MODULES = [
    NzIconModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzButtonModule
];
@NgModule({
    providers: [AuthService],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        AuthRoutingModule,
        NzSpinModule,
        NzCardModule,
        TranslateModule.forChild(),
        SharedModule,
        ...NZ_MODULES
    ],
    declarations: [
        // ResetPasswordComponent,
        // SetPasswordComponent,
        // LoginComponent,
        // ForgotPasswordComponent,
        // ChangePasswordComponent,
    ],
    exports: []
})
export class AuthModule {}
